import {Component, ElementRef, HostListener, Input, OnDestroy, OnInit} from '@angular/core';
import {PlanningOrder} from '@domain/planning/planning-order';
import {ProductionScheduleStatus} from '@domain/production-schedule/production-schedule-status.enum';
import {RepositionTooltipComponent} from '@presentation/components/reposition-tooltip/reposition-tooltip.component';
import {BaseComponent, DialogBuilder, DialogBuilderFactoryService, DOMUtils} from '@vdw/angular-component-library';
import {takeUntil} from 'rxjs';
import {PlanningSmallOrderCardInfoComponent} from './planning-small-order-card-info/planning-small-order-card-info.component';

@Component({
  selector: 'app-planning-order-card',
  templateUrl: './planning-order-card.component.html',
  styleUrls: ['./planning-order-card.component.scss']
})
export class PlanningOrderCardComponent extends BaseComponent implements OnInit, OnDestroy {
  @Input() public machineRunTitle: string;
  @Input() public planningOrder: PlanningOrder;
  @Input() public compatibleWithMachine: boolean;
  @Input() public shouldShowRightBorder: boolean;

  public shouldShowSmallInfo = false;
  private readonly SMALL_ORDER_THRESHOLD = 72;

  private dialogBuilder: DialogBuilder = null;

  public constructor(
    private readonly element: ElementRef<HTMLElement>,
    private readonly dialogBuilderFactoryService: DialogBuilderFactoryService
  ) {
    super();
  }

  public ngOnInit(): void {
    DOMUtils.observeResize(this.element.nativeElement)
      .pipe(takeUntil(this.unSubscribeOnViewDestroy))
      .subscribe((entries: ResizeObserverEntry[]) => {
        this.shouldShowSmallInfo = entries[0].contentRect.width < this.SMALL_ORDER_THRESHOLD;
      });
  }

  @HostListener('mouseenter')
  public onMouseEnter(): void {
    if (this.shouldShowSmallInfo && this.dialogBuilder === null) {
      this.openDetailsTooltip();
    }
  }

  @HostListener('mouseleave')
  public onMouseLeave(): void {
    if (this.dialogBuilder !== null) {
      this.closeDetailsTooltip();
    }
  }

  public getIconNameForProductionOrderStatus(): string {
    return ProductionScheduleStatus.getStatusIconName(this.planningOrder.productionOrder.status);
  }

  public openDetailsTooltip(): void {
    this.dialogBuilder = this.dialogBuilderFactoryService.getBuilder();

    this.dialogBuilder.withClass('reposition-tooltip').withMaxWidth('408px').withoutBackdrop().openDialog(RepositionTooltipComponent, {
      forceArrowCentered: true,
      title: this.machineRunTitle,
      planningOrder: this.planningOrder,
      differentConfiguration: !this.compatibleWithMachine,
      component: PlanningSmallOrderCardInfoComponent,
      targetDOMRect: this.element.nativeElement.getBoundingClientRect(),
      iconNameForProductionStatus: this.getIconNameForProductionOrderStatus()
    });
  }

  public override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.closeDetailsTooltip();
  }

  private closeDetailsTooltip(): void {
    this.dialogBuilder?.close();
    this.dialogBuilder = null;
  }
}
